import React from 'react';
import PropTypes from 'prop-types';

import SocialLinks from 'components/SocialLinks';
import Thumbnail from 'components/Thumbnail';

import styles from './styles.module.scss';

const ArticlePoster = ({
	children,
	showPlaceholderImage,
	socials,
	placeholderAlign,
	placeholderType,
	thumbnailAlt,
	thumbnailFile,
	title
}) => (
	<>
		{(thumbnailFile || showPlaceholderImage) && (
			<Thumbnail
				className={styles.ArticlePoster__Thumbnail}
				file={thumbnailFile}
				params={{ width: 884, height: 442 }}
				placeholderAlign={placeholderAlign}
				placeholderType={placeholderType}
				alt={thumbnailAlt}
				keepRatio
				showMeta
			/>
		)}
		<div className={styles.ArticlePoster__Body}>
			<h1 className={styles.ArticlePoster__Title}>{title}</h1>
			{children}
		</div>
		{!!socials?.length && (
			<div className={styles.ArticlePoster__Social}>
				<SocialLinks data={socials} spacing="middle" theme="bright" />
			</div>
		)}
	</>
);

ArticlePoster.propTypes = {
	children: PropTypes.node,
	showPlaceholderImage: PropTypes.bool,
	socials: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			icon: PropTypes.string,
			url: PropTypes.string
		})
	),
	placeholderAlign: PropTypes.string,
	placeholderType: PropTypes.string,
	title: PropTypes.string.isRequired,
	thumbnailAlt: PropTypes.string,
	thumbnailFile: PropTypes.object
};

export default ArticlePoster;
